import { Timestamp, serverTimestamp } from 'firebase/firestore'
import type { UserFavourite } from '@domain/models/user-favourite'

function toOptionalDate(value: unknown): Date | undefined {
  if (value instanceof Timestamp) {
    return value.toDate()
  }
  if (value instanceof Date) {
    return value
  }
  return undefined
}

export class UserFavouriteConverter {
  public static fromFirestore(
    uid: string,
    data: Record<string, unknown>,
  ): UserFavourite {
    return {
      uid,
      userId: typeof data.user_id === 'string' ? data.user_id : '',
      createdTime: toOptionalDate(data.created_time),
      type: typeof data.type === 'string' ? data.type : '',
      itemId: typeof data.item_id === 'string' ? data.item_id : '',
    }
  }

  public static toFirestore(
    favourite: Omit<UserFavourite, 'uid'>,
  ): Record<string, unknown> {
    const payload: Record<string, unknown> = {
      user_id: favourite.userId,
      type: favourite.type,
      item_id: favourite.itemId,
      created_time: favourite.createdTime
        ? Timestamp.fromDate(favourite.createdTime)
        : serverTimestamp(),
    }

    return payload
  }
}
